import Keycloak from 'keycloak-js';
import type { KeycloakConfig } from 'keycloak-js';

/**
 * Creates a Keycloak instance with the provided configuration.
 * This is the core factory function for creating Keycloak instances.
 * 
 * @param config - Keycloak configuration (url, realm, clientId)
 * @returns Configured Keycloak instance
 */
export function createKeycloakInstance(config: KeycloakConfig): Keycloak {
  if (!config.url || !config.realm || !config.clientId) {
    throw new Error('Missing required Keycloak configuration: url, realm, and clientId are required');
  }

  const keycloakConfig = {
    url: config.url,
    realm: config.realm,
    clientId: config.clientId,
  };

  return new Keycloak(keycloakConfig);
}

/**
 * Creates a Keycloak instance from environment variables.
 * This is a convenience function for common use cases.
 * 
 * @param envConfig - Environment-based configuration
 * @returns Configured Keycloak instance
 */
export function createKeycloakFromEnv(envConfig: KeycloakConfig): Keycloak {
  return createKeycloakInstance({
    url: envConfig.url,
    realm: envConfig.realm,
    clientId: envConfig.clientId,
  });
}


